import { RESPONSE_FILTER } from 'constants/common';

export const getNewResponseFilterParam = (param: undefined | string) => {
  if (param === RESPONSE_FILTER.PARTS) return RESPONSE_FILTER.DIAGRAM;
  if (param === RESPONSE_FILTER.DIAGRAM) return RESPONSE_FILTER.PARTS;

  return RESPONSE_FILTER.DIAGRAM;
};
